<app-help-hero (searchChange)="searchTerm = $event"></app-help-hero>
<app-help-contact></app-help-contact>
<app-help-faq [searchTerm]="searchTerm"></app-help-faq>
